/* global Sys, Utils */
Sys.ns("Utils");

Utils.CONSTANTS = {
    JURISDICTION_SPECIFIC_CODES: {
        SHOW_GAME_INFORMATION: ["CH"]
    },

    REASON_CODES: {

        /*
            gameId: The game ID of the game that triggered the "bounce-back".
            sessionId: The game session ID (starting with DEMO if it is a "Play for Fun" session).
            reason: A code defining the reason for going back to the lobby.

            "0" = A normal game termination (the player selected to go to the lobby using the lobby button in the game).
            "1" = The game was started from a bookmark; a login (real or for fun) is required to obtain a web session and play the game.
            "3" = Session time-out.
            "4" = Play for real promotion has been displayed in-game, and the player wants to register and play for real money.
            "5" = The player ran out of money when playing a game, and wants to deposit more money.
            "6" = The device is confirmed but not supported.
            "9" = An error occurred in the game and the player chose to go to the lobby.
            "11" = When player acknowledges Player Limit and terminates.
            "12" = The game redirect to lobby, if the game is refreshed without iframe using a desktop user agent.
        */
        NORMAL_GAME_TERMINATION: "0",
        BOOKMARK: "1",
        SESSION_TIMEOUT: "3",
        WANTS_TO_PLAY_FOR_REAL: "4",
        WANTS_TO_DEPOSIT_MONEY: "5",
        DEVICE_NOT_SUPPORTED: "6",
        TECHNICAL_ERROR: "9",
        ACKNOWLEDGES_PLAYER_LIMIT: "11",
        NON_COMPLIANT: "12"
    },

    DIALOG_NAMES: {
        // Bonus message dialog.
        BONUS_MESSAGE: "bonusMessage",
        // Round restore message.
        RESTORE_MESSAGE: "restoreMessage",
        // Play 4 fun dialog.
        PLAY_4_REAL: "playForRealPromo",
        // Reality check dialog.
        REALITY_CHECK: "realityCheck",
        // Free rounds intro dialog.
        FREE_ROUNDS_START: "freeRoundsStart",
        // Free rounds outro dialog.
        FREE_ROUNDS_END: "freeRoundsEnd",
        // Free rounds extra rounds.
        FREE_ROUNDS_EXTRA: "freeRoundsExtra",
        // Reload game free rounds finished. Probably not used anymore.
        FREE_ROUNDS_RELOAD: "freeRoundsReload",
        // Warning when cash decreases stop condition is not set but requiered.
        CASH_DECREASES_WARNING: "cashDecreasesWarning",
        // When bet is bigger than cash decreases limit
        BET_OVERLAPPING: "betOverlapping",
        // When bet is bigger than cash decreases limit on mobile
        BET_OVERLAPPING_MOBILE: "betOverlappingMobile",
        // Dialog requested through net ent extend
        NEE_DIALOG: "NEEDialog",

        // errors
        CONNECTION_LOST: "connectionLost",
        // Player reached play limit.
        PLAY_LIMIT: "playLimit_11",
        EXPIRED_FREE_ROUNDS: "expiredFreeRounds_12",
        MAX_BET_LIMIT: "maxBetLimit_13",
        // Free rounds program already used.
        FREE_ROUNDS_USED: "freeRoundsOfferUsed_14_16",
        SESSION_TIMEOUT: "sessionTimeout_20",
        OUT_OF_MONEY: "outOfMoney",
        GAME_UNAVAILABLE: "gameUnavailable",
        ACCOUNT_UNAVAILABLE: "accountUnavailable",
        TECHNICAL_ERROR: "technicalError",
        // Game lost connection due to inactivity
        GAME_UNAVAILABLE_INACTIVE: "gameUnavailableInactive"
    }
};
